class LicenseRequestFormInputs {
  constructor(data) {
    this.licenseRequestFormInputId = data.id
    this.name = data.n;
    this.isRequired = data.ir;
    this.licenseRequestFormInputTypeId = data.lrfiti;
  }
}

export default LicenseRequestFormInputs
